import React from 'react';

const Step2 = () => (
  <div>
    <p><strong>Jot down names</strong> as you think of them. You can add plus ones and children, too.</p>
    <video muted playsInline autoPlay preload="auto" loop>
      <source src="https://zola-web-assets.s3.us-east-1.amazonaws.com/web-wedding/guest-list-animations/Add-Individual.mp4" type="video/mp4" />
      Sorry, your browser doesn&apos;t support embedded videos.
    </video>
  </div>
);

export default Step2;



// WEBPACK FOOTER //
// ./src/pages/TourSteps/Step2.jsx